/*
 * File: cell-action-translation-job-resolve.ts
 * Created: 2026-02-24
 * Author: Val Liu
 */

import { Component, Watch } from "vue-property-decorator";
import CellActionBase from "@root/components/table/elements/body/cell-action/base/cell-action-base";

@Component
export default class CellActionTranslationJobResolve extends CellActionBase {
    showModal = false;
    resolveMessage = "";

    get defaultLabel(): string {
        return this.label ?? "w_TranslationJobResolve";
    }

    get modalTitle(): string {
        return "w_TranslationJobResolveTitle";
    }

    get isDisabled(): boolean {
        return !this.resolveMessage.trim();
    }

    @Watch("row", { immediate: true, deep: true })
    handleRowChange() {
        const status = String(this.row?.errorStatus ?? "").toUpperCase();
        this.setVisible(status === "CRITICAL");
        if (this.showModal) {
            this.resolveMessage = String(this.row?.resolveMessage ?? "");
        }
    }

    openModal(event: Event) {
        if (!this.isVisible) {
            event.preventDefault();
            return;
        }
        this.resolveMessage = String(this.row?.resolveMessage ?? "");
        this.showModal = true;
    }

    async handleSubmit() {
        const id = this.row?.id;
        const message = this.resolveMessage.trim();
        if (!id || !message) return;

        try {
            await this.$server.U("translation-job" as any, {
                data: {
                    errorStatus: "RESOLVED",
                    resolveMessage: message,
                },
                where: { id },
            });
            this.showModal = false;
            this.doTableReload();
        } catch (error) {
            this.console?.error?.(error);
            if ((error as any)?.handled) return;
        }
    }
}
